import { useCallback } from 'react';

import type { QueuedModalDescriptor } from './hcp-verification-ports';
import { HCP_VERIFICATION_OPEN_QUEUE_ITEM } from './hcp-verification-queue-items';

/**
 * Opens the clinician (NPI) verification dialog on demand by enqueueing the
 * CRITICAL user-triggered item. Idempotent — the queue dedupes by id.
 * `enqueueModal` is the app queue's writer, supplied at the composition point.
 */
export const useOpenHcpVerificationModal = (
  enqueueModal: (modal: QueuedModalDescriptor) => void
) => useCallback(() => enqueueModal(HCP_VERIFICATION_OPEN_QUEUE_ITEM), [enqueueModal]);
